import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import auTranslations from './au.json';
import enTranslations from './en.json';
import thTranslations from './th.json';

let activeLng = 'en';

switch (process.env.REACT_APP_REGION) {
  case 'AU':
    activeLng = 'au';
    break;
  case 'TH':
    activeLng = 'th';
    break;
  default:
    activeLng = 'en';
    break;
}

i18n.use(initReactI18next).init({
  resources: {
    en: enTranslations,
    th: thTranslations,
    au: auTranslations,
  },
  fallbackLng: 'en',
  lng: activeLng,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
